<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="terminar()">
        <b-container>
            <b-row>
                <b-col cols="12" class="h3 mb-4">
                    {{ $t('partido.completar_datos') }}
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <FormInput :label="$t('formularios.nombre')" id="nombre" :name="$t('formularios.nombre')" rules="required" v-model="datos_comprador.nombre" />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <FormInput :label="$t('formularios.apellidos')" id="apellidos" :name="$t('formularios.apellidos')" rules="required" v-model="datos_comprador.apellidos" />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <DocumentoTipo
                        v-model="datos_comprador.tipoDocumento"
                        :index="0"
                    />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <DocumentoValor
                        v-model="datos_comprador.dni"
                        :type="datos_comprador.tipoDocumento"
                        :index="0"
                    />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <FormInput :label="$t('formularios.cp')" id="cp" :name="$t('formularios.cp')" rules="required" v-model="datos_comprador.cp" />
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <div class="form-group">
                        <label for="nombre">Email</label>
                        <ValidationProvider name="email" rules="required|email" vid="confirmation" mode="passive" v-slot="{ errors }">
                            <input type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="email" placeholder="Email" v-model="datos_comprador.email"/>
                            <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <div class="form-group">
                        <label>{{ $t('formularios.confirmar_email') }}</label>
                        <ValidationProvider :name="$t('formularios.confirmar_email')" :rules="'required|confirmed_ci:@confirmation'" mode="passive" v-slot="{ errors }">
                            <input type="" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.confirmar_email')" v-model="datos_comprador.email_confirmation" id="email_confirmation"/>
                            <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>                            
                    </div>
                </b-col>
                <b-col sm="12" md="6" lg="4">
                    <div class="form-group">
                        <label>{{ $t('formularios.telefono') }}</label>
                        <PhoneInput 
                            :phone="datos_comprador.telefono ?? null"
                            :desactivar="false"
                            :required="false"
                            @setNumber="(number) => datos_comprador.telefono = number"
                            @validNumber="(valid) => isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <template v-if="fields && fields.length > 0">
                    <div v-for="(field, index) in fields" :key="index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4 col-md-6' : '')">
                        <FieldComponent 
                            :field="field" 
                            :desactivar="false" 
                            v-model="datos_comprador.properties[field.name]"
                        />
                    </div>
                </template>
                <b-col cols="12">
                    <DatosProductosComponent :productos="productos" />
                </b-col>
                <b-col cols="12" class="mt-1 mt-md-2">
                    <button :class="'button' + (!esMovil ? ' large-button effect-button' : '')" type="submit" :disabled="loading">
                        <span>{{ $t('formularios.continuar') }}</span>
                    </button>
                    <button :class="'button ml-2' + (!esMovil ? ' large-button effect-button' : '')" type="button" :disabled="loading" @click="$emit('changeStep', true)">
                        <span>{{ $t('formularios.atras') }}</span>
                    </button>
                </b-col>
            </b-row>
        </b-container>
    </ValidationObserver>
</template>

<script>
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import FieldComponent from '@/components/common/FieldComponent';
    import DatosProductosComponent from '../events/compra/components/productos/DatosProductosComponent.vue';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';

    export default {
        props: {
            datos_comprador: {
                type: Object,
                required: true
            },
            jet_id: {
                required: false
            },
            formulario: {
                required: false
            },
            fields: {
                type: Array,
                required: true
            },
            session_id: {
                required: true,
            },
            session_id_carrito: {
                required: true,
            },
            productos: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                isValidNumber: false,
                esMovil: false
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            async terminar() {
                const isValid = await this.$refs.observer.validate();

                if (isValid && this.isValidNumber) {
            
                    this.loading = true;

                    const params = {
                        filters: {
                            sesion_id: this.session_id,
                            tid: this.$store.getters.getTeatro.hash
                        },
                        datos_compradores: this.datos_comprador,
                        session_id: this.session_id_carrito
                    }
                    this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                        this.$emit('update:jet_id', res.data.jet_id);
                        this.$emit('update:formulario', res.data.formulario);
                        this.$emit('changeStep');
                        this.$toast.success('Datos guardados correctamente');
                    }).finally(() => this.loading = false); 
                }
            },
            onResize() {
                this.esMovil = window.innerWidth < 768;
            },
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true });
            }
        },
        mounted() {
            this.onResize();
            window.addEventListener('resize', this.onResize, { passive: true });
        },
        created() {
            if (this.fields && this.fields.length > 0) {
                this.datos_comprador.properties = {};
                this.fields.forEach(field => {
                    this.datos_comprador.properties[field.name] = '';
                });
            }

            if (!this.datos_comprador.tipoDocumento) {
                this.$set(this.datos_comprador, 'tipoDocumento', 'DNI');
            }
        },
        components: {
            PhoneInput, FieldComponent, DatosProductosComponent, DocumentoTipo, DocumentoValor
        }
    }
</script>